/* eslint-disable no-unused-vars */
import { Button } from '@mui/material';
import { NavLink, useLocation, Link } from 'react-router-dom';
import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CloseIcon from '@mui/icons-material/Close';
import MenuItems from './menu';

const enabbelSighUp = false;
const MainMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorChildEl, setAnchorChildEl] = React.useState(false);
  const [subMenu, setSubMenu] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSubMenu(false);
  };
  const handleNestedClick = (event) => {
    setAnchorChildEl(!anchorChildEl);
  };
  return (
    <div className="mainMenu">
      <MenuIcon aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} fontSize="small" />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="responsiveMenu"
      >
        <MenuItem onClick={handleClose}><CloseIcon fontSize="small" /></MenuItem>
        <MenuItems setSubMenu={setSubMenu} setAnchorEl={setAnchorEl} subMenu={subMenu} mobileMenu="true" />
      </Menu>
    </div>
  );
};

export default MainMenu;
